import { render, staticRenderFns } from "./addTest.vue?vue&type=template&id=4b3185bd&scoped=true&"
import script from "./addTest.vue?vue&type=script&lang=js&"
export * from "./addTest.vue?vue&type=script&lang=js&"
import style0 from "./addTest.vue?vue&type=style&index=0&id=4b3185bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3185bd",
  null
  
)

export default component.exports